import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";

const ModalProcessPreparationStep = ({ open, onClose, onProcess, isLoading, selectedProcessData, isTimeDisabled}) => {
  const CancelButton = styled(Button)({
    backgroundColor: "#DE3436",
    color: "white",
    "&:hover": {
      backgroundColor: "#DC1F21",
    },
  });

  const ConfirmButton = styled(Button)({
    backgroundColor: "#469F3F",
    color: "white",
    "&:hover": {
      backgroundColor: "#32932B",
    },
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw",
            sm: 400,
          },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "0px solid #000",
          boxShadow: 24,
          p: {
            xs: 2,
            sm: 4,
          },
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        {selectedProcessData ? (
          <>
            <Typography sx={{ mt: 2, fontSize: "18px", color: "#383838" }}>
              Apakah anda yakin untuk memproses <br />Step {selectedProcessData.position} - {selectedProcessData.description}?
            </Typography>
            <Box mt={4} display="flex" justifyContent="flex-end">
              <CancelButton
                onClick={onClose}
                style={{ marginRight: "8px" }}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Tidak"}
              </CancelButton>
              <ConfirmButton onClick={onProcess} disabled={isLoading || (isTimeDisabled && selectedProcessData === "Transfer/Posting Data")}>
                {isLoading ? "Loading..." : "Ya"}
              </ConfirmButton>
            </Box>
          </>
        ) : (
          <Typography sx={{ mt: 2, fontSize: "18px", color: "#383838" }}>
            Data preparation step is not selected.
          </Typography>
        )}
      </Box>
    </Modal>
  );
};

export default ModalProcessPreparationStep;
